export default class IframeSizeHandler {
    static IFRAME_SELECTOR = '.iframe'

    constructor() {
        this.iFrame = document.querySelector(IframeSizeHandler.IFRAME_SELECTOR);
        if (this.iFrame) this.initEventListener();
    }

    scrollIntoViewWithOffset = (selector, offsetSelector) => {

        let offsetTop = 0;
        if (document.querySelector(offsetSelector)) {
            offsetTop = document.querySelector(offsetSelector).clientHeight;
        }

        window.scrollTo({
            behavior: 'smooth',
            top:
                document.querySelector(selector).getBoundingClientRect().top -
                document.body.getBoundingClientRect().top -
                offsetTop,
        })
    }

    handleResizeMessage = (event) => {
        if (event.data.type === 'iframeResize') {
            const height = event.data.height;
            if (height) {
                // Set the iframe height to the received value
                this.iFrame.style.height = height + 'px';
            }
            if (event.data.behaviour === 'scrollIntoView') {
                this.scrollIntoViewWithOffset(IframeSizeHandler.IFRAME_SELECTOR, 'header');
            }
        }
    };

    initEventListener() {
        // Listen for messages from iframes
        window.addEventListener('message', this.handleResizeMessage);
    }

}
